<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-store"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingShop"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <base-subheading>
                      {{ $t('fields.shop.subtitles.general') }}
                    </base-subheading>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:250"
                          name="shop.name"
                        >
                          <v-text-field
                            v-model="shop.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.shop.name')"
                            outlined
                          />
                        </validation-provider>
                        {{ shop.balance }}
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:250"
                          name="shop.ComercialName"
                        >
                          <v-text-field
                            v-model="shop.comercialName"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.shop.comercialName')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:500"
                          name="shop.schedule"
                        >
                          <v-textarea
                            v-model="shop.schedule"
                            outlined
                            name="horario"
                            :label="$t('fields.shop.schedule')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="shop.shopType"
                        >
                          <v-select
                            v-model="shop.shopTypeId"
                            :items="shopTypes"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.shop.shopType')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <base-subheading>
                      {{ $t('fields.shop.subtitles.address') }}
                    </base-subheading>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:500"
                          name="shop.addressLine"
                        >
                          <v-textarea
                            v-model="shop.addressLine"
                            outlined
                            name="address"
                            :label="$t('fields.shop.addressLine')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="shop.province"
                        >
                          <v-select
                            v-model="shop.provinceId"
                            :items="provinces"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.shop.province')"
                            :error-messages="errors"
                            outlined
                            @change="changeProvince(shop.provinceId)"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="shop.county"
                        >
                          <v-select
                            v-model="shop.countyId"
                            :items="counties"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.shop.county')"
                            :error-messages="errors"
                            outlined
                            @change="changeCounty(shop.countyId)"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="shop.district"
                        >
                          <v-select
                            v-model="shop.districtId"
                            :items="districts"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.shop.district')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-expansion-panels accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{ $t('fields.shop.subtitles.other-information') }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <base-subheading>
                              {{ $t('fields.shop.subtitles.owner') }}
                            </base-subheading>
                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.name") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:250"
                                  name="fields.shop.name"
                                >
                                  <v-text-field
                                    v-model="shop.owner"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.phone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.phone"
                                >
                                  <v-text-field
                                    v-model="shop.ownerPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.cellPhone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.cellPhone"
                                >
                                  <v-text-field
                                    v-model="shop.ownerCellPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <div class="my-6" />

                            <base-subheading>
                              {{ $t('fields.shop.subtitles.manager') }}
                            </base-subheading>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.name") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:250"
                                  name="fields.shop.name"
                                >
                                  <v-text-field
                                    v-model="shop.manager"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.phone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.phone"
                                >
                                  <v-text-field
                                    v-model="shop.managerPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.cellPhone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.cellPhone"
                                >
                                  <v-text-field
                                    v-model="shop.managerCellPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6"
                          >
                            <base-subheading>
                              {{ $t('fields.shop.subtitles.ownerShop') }}
                            </base-subheading>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.name") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:250"
                                  name="fields.shop.name"
                                >
                                  <v-text-field
                                    v-model="shop.ownerShop"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.phone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.phone"
                                >
                                  <v-text-field
                                    v-model="shop.ownerShopPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.cellPhone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="nombre comercial"
                                >
                                  <v-text-field
                                    v-model="shop.ownerShopCellPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <div class="my-6" />

                            <base-subheading class="mb-6">
                              {{ $t('fields.shop.subtitles.ownerPatent') }}
                            </base-subheading>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.name") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:250"
                                  name="fields.shop.name"
                                >
                                  <v-text-field
                                    v-model="shop.ownerPatent"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.phone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.phone"
                                >
                                  <v-text-field
                                    v-model="shop.ownerPatentPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              dense
                            >
                              <v-col
                                class="text-right body-1 grey--text"
                                cols="2"
                              >
                                {{ $t("fields.shop.cellPhone") }}
                              </v-col>

                              <v-col cols="8">
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="max:20"
                                  name="fields.shop.cellPhone"
                                >
                                  <v-text-field
                                    v-model="shop.ownerPatentCellPhone"
                                    :error-messages="errors"
                                    color="secondary"
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>

                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="cancel"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <v-row v-if="formAction !== 'add'">
      <v-col cols="12">
        <shop-machine-list
          :shop="shop"
          :shop-id="$route.params.id"
        />
      </v-col>
    </v-row>
    <base-material-snackbar
      v-model="showSuccessAlert"
      :dismissible="false"
      type="success"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['timeout']: 1000
      }"
    >
      <span class="text-uppercase">{{ $t('success') }} :</span>
    </base-material-snackbar>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const shopRespository = repositoryFactory.get('shops')
  const parameterRespository = repositoryFactory.get('parameters')
  const addressesRespository = repositoryFactory.get('addresses')

  export default {
    inject: ['theme'],
    name: 'ShopCrud',
    $_veeValidate: {
      validator: 'new',
    },
    components: {
      ShopMachineList: () => import('./ShopMachineList'),
    },
    data: () => ({
      shop: {},
      shopTypes: [],
      districts: [],
      provinces: [],
      counties: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingShop: false,
      showSuccessAlert: false,
      formAction: null,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-shop') : this.$t('modify-shop')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingShop = true
        var id = this.$route.params.id
        shopRespository.getById(id).then(response => {
          self.loadingShop = false
          self.shop = Object.assign({}, response.data.data)

          this.getCounties(self.shop.provinceId)
          this.getDistricts(self.shop.countyId)
        }).catch(err => {
          self.loadingShop = false
          alert(err)
        })

        shopRespository.getActiveMachines(id).then(response => {
          self.shop.machines = Object.assign({}, response.data.data)
        }).catch(err => {
          alert(err)
        })
      }
      this.getShopTypes()
      this.getProvinces()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.shop,
        }

        if (self.formAction !== 'add') {
          shopRespository.updateShop(data, this.shop.id).then(response => {
            if (response.data.isValid) {
              self.showSuccessAlert = true
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        } else {
          shopRespository.addShop(data).then(response => {
            if (response.data.isValid) {
              self.shop = response.data.data
              self.showSuccessAlert = true
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        }
      },
      getProvinces () {
        var self = this
        addressesRespository.getProvinces().then(response => {
          self.provinces = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getCounties (provinceId) {
        var self = this
        addressesRespository.getCounties(provinceId).then(response => {
          self.counties = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getDistricts (countyId) {
        var self = this
        addressesRespository.getDistricts(countyId).then(response => {
          self.districts = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getShopTypes () {
        var self = this
        parameterRespository.getShopTypes().then(response => {
          self.shopTypes = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      changeProvince (provinceId) {
        this.getCounties(provinceId)
        this.shop.districtId = null
        this.shop.countyId = null
        this.districts = []
      },
      changeCounty (countyId) {
        this.getDistricts(countyId)
        this.shop.districtId = null
      },
      cancel () {
        this.$router.push({ name: 'shops' })
      },
    },
  }
</script>
